import { useEffect, useState } from 'react';
import { IconAlert, IconCheck } from './Icons';
import { makeId } from '../lib/format';

export type ToastTone = 'good' | 'bad' | 'plain';

interface Toast {
  id: string;
  message: string;
  tone: ToastTone;
}

const listeners = new Set<(toasts: Toast[]) => void>();
let toasts: Toast[] = [];

function emit() {
  listeners.forEach((l) => l(toasts));
}

/** Fire-and-forget notification. Callable from anywhere, no context needed. */
export function toast(message: string, tone: ToastTone = 'plain'): void {
  const item: Toast = { id: makeId('toast'), message, tone };
  toasts = [...toasts, item].slice(-4);
  emit();
  window.setTimeout(() => {
    toasts = toasts.filter((t) => t.id !== item.id);
    emit();
  }, 4200);
}

export function Toaster() {
  const [items, setItems] = useState<Toast[]>(toasts);

  useEffect(() => {
    listeners.add(setItems);
    return () => {
      listeners.delete(setItems);
    };
  }, []);

  return (
    <div className="toast-stack" role="status" aria-live="polite">
      {items.map((t) => (
        <div key={t.id} className={`toast ${t.tone === 'good' ? 'is-good' : t.tone === 'bad' ? 'is-bad' : ''}`}>
          {t.tone !== 'plain' && (
            <span
              className="t-icon"
              style={{ color: t.tone === 'good' ? 'var(--accent)' : 'var(--accent-2)' }}
            >
              {t.tone === 'good' ? <IconCheck size={15} /> : <IconAlert size={15} />}
            </span>
          )}
          <span>{t.message}</span>
        </div>
      ))}
    </div>
  );
}
